'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect } from 'react';
import { Box } from '@gemini/core';
import { MinusIcon, PlusIcon } from '@gemini/icons';
import { FloatingButtonGroup } from '@gemini/ui';
import { useMapContext } from '@/hooks/useMapContext/useMapContext';
import { useMobileViewDetect } from '@/hooks/useMobileViewDetect/useMobileViewDetect';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
import { Logger } from '@/logger';
export const MapContainer = forwardRef(() => {
    const { map, mapContainerRef: ref } = useMapContext();
    const { t } = useShellTranslation();
    const { isMobileView } = useMobileViewDetect();
    useEffect(() => {
        if (!map) {
            return;
        }
        map.on('error', (error) => {
            let message = 'Unknown error';
            if (error instanceof Error) {
                message = error.message;
            }
            else if (typeof error === 'object' && error !== null) {
                message = error.error?.message ?? '[Non-Error object]';
            }
            Logger.error(`[MapContainer] ${message}`);
        });
    }, [map]);
    return (_jsxs(_Fragment, { children: [!isMobileView && (_jsx(FloatingButtonGroup, { position: "absolute", bottom: "spacing.32", right: "spacing.24", zIndex: "zIndex.4", items: [
                    {
                        id: 'ZoomIn',
                        icon: PlusIcon,
                        onPress: () => map?.zoomIn(),
                        children: t('map::zoom_in::title'),
                    },
                    {
                        id: 'ZoomOut',
                        icon: MinusIcon,
                        onPress: () => map?.zoomOut(),
                        children: t('map::zoom_out::title'),
                    },
                ] })), _jsx(Box, { height: "100%", ref: ref })] }));
});
